import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue';
import moment from 'moment';
import { useFilterStore, useUiStore } from '@/stores';
import { AgentDeviceStatusHistoryReportService, toastServiceError } from '@/services';
import { formatSecToTime } from '@/utils/datetime';
import {
    Permission,
    UserDeviceType,
    AgentDeviceStatusHistoryReportServiceGetInfoResult,
} from '@/types';

import SVGChromeLogo from '@/components/svg/SVGChromeLogo.vue';
import SVGDeviceExternal from '@/components/svg/SVGDeviceExternal.vue';
import { DesktopComputerIcon } from '@heroicons/vue/solid';
import { DeviceMobileIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentDeviceReportPage',
  setup(__props, { expose: __expose }) {
  __expose();

const filterStore = useFilterStore();
const uiStore = useUiStore();

const dateRange = computed({
    get: () => filterStore.dateRange,
    set: (range: Array<Date>) => filterStore.setDateRange(range),
});

const levelFilter = computed(() => filterStore.level);
const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const agents = ref<AgentDeviceStatusHistoryReportServiceGetInfoResult[]>([]);
const totalTimePaused = ref(0);
const totalTimeCall = ref(0);

const tableHeaders = [
    { key: 'name', label: 'report.agentDeviceStatusHistory.details.userName', align: 'left' },
    {
        key: 'extension',
        label: 'report.agentDeviceStatusHistory.details.extension',
        align: 'center',
    },
    {
        key: 'queues',
        label: 'report.agentDeviceStatusHistory.details.queues',
        align: 'center',
    },
    {
        key: 'totalConnectedTime',
        label: 'report.agentDeviceStatusHistory.details.totalTimeOnline',
        align: 'center',
    },
    {
        key: 'totalPauseTime',
        label: 'report.agentDeviceStatusHistory.details.totalTimePaused',
        align: 'center',
    },
    {
        key: 'totalCallDuration',
        label: 'report.agentDeviceStatusHistory.details.totalTimeInCall',
        align: 'center',
    },
];

const getDeviceIcon = (deviceType: string) =>
    ({
        [UserDeviceType.MOBILE]: DeviceMobileIcon,
        [UserDeviceType.DESKTOP]: DesktopComputerIcon,
        [UserDeviceType.WEB]: SVGChromeLogo,
        [UserDeviceType.EXTERNAL]: SVGDeviceExternal,
    })[deviceType];

const getReportData = async () => {
    const params = {
        startDate: moment.utc(dateRange.value[0]).format('YYYY-MM-DD'),
        endDate: moment.utc(dateRange.value[1]).format('YYYY-MM-DD'),
    };

    try {
        setLoading(true);
        const { data } = await AgentDeviceStatusHistoryReportService.getInfo({ params });

        agents.value = data;
        totalTimePaused.value = data.reduce((acc, curr) => acc + (curr.totalPauseTime || 0), 0);
        totalTimeCall.value = data.reduce((acc, curr) => acc + (curr.totalCallDuration || 0), 0);
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

watch([levelFilter, dateRange], getReportData);
onMounted(getReportData);

const __returned__ = { filterStore, uiStore, dateRange, levelFilter, setLoading, agents, totalTimePaused, totalTimeCall, tableHeaders, getDeviceIcon, getReportData, get formatSecToTime() { return formatSecToTime }, get Permission() { return Permission } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})